import request from "../../utils/axios";

export const apiCreateCallLog = async (data) => {
  const res = await request.post({ url: "/member/call-log/create", data });
  return res;
};

export const apiUpdateCallLog = async (data) => {
  const res = await request.put({ url: "/member/call-log/update-by-callid", data });
  return res;
};

// 查询分页
export const getCallLogPage = async (params) => {
  const res = await request.get({ url: `/member/call-log/page`, params })
  return res;
};
